import React from 'react';
import { FilterOutlined, FilterFilled } from '@ant-design/icons';
import TableSorter from '../../../global/tableFilters/TableSorter';
import TableFilterPopover from '../../../global/tableFilters/TableFilterPopover';

interface ConfigurationHeaderCellProps {
  label: string;
  filterValues?: { id: number; name: string }[];
  handleFilterChange?: (selectedIds: number[]) => void;
  selectedFilterIds?: number[];
  showSearch?: boolean;
  filterHeight?: number;
  sortColumn?: string;
  currentSortColumn?: string;
  sortOrder?: string;
  onSort?: (order: string) => void;
}

const ConfigurationHeaderCell: React.FC<ConfigurationHeaderCellProps> = ({
  label,
  filterValues,
  handleFilterChange,
  selectedFilterIds = [],
  showSearch = false,
  filterHeight,
  sortColumn,
  currentSortColumn,
  sortOrder,
  onSort,
}) => {
  const canFilter = filterValues && handleFilterChange;
  const canSort = sortColumn && onSort;
  const isFiltered = selectedFilterIds.length > 0;

  return (
    <div className="flex flex-row items-center">
      {label}
      {canFilter && (
        <div className="ml-3">
          <TableFilterPopover
            values={filterValues}
            handleChange={handleFilterChange}
            initiallySelectedIds={selectedFilterIds}
            showSearch={showSearch}
            height={filterHeight}
          >
            {isFiltered ? <FilterFilled className="table-filter-blue" /> : <FilterOutlined />}
          </TableFilterPopover>
        </div>
      )}
      {canSort && (
        <div className="ml-1">
          <TableSorter
            selected={currentSortColumn === sortColumn}
            sortOrder={sortOrder}
            handleSort={onSort}
          />
        </div>
      )}
    </div>
  );
};

export default ConfigurationHeaderCell;
